// REACT
import React from 'react';
import { useContext } from "react";

// ASSETS
import languagePack from "../../assets/languages/languagePack";
import "../../assets/styles/confirmModal.css"; // Separate CSS file for ConfirmModal
import { Button } from "react-bootstrap";
import { MdCancel } from "react-icons/md";
import { MdDeleteForever } from "react-icons/md";

// CONTEXT
import { maincontext } from "../../context/maincontext";

// COMPONENTS
import Loading from './Loading';

export default function ConfirmModal(props) {
    const { language } = useContext(maincontext);

    return (
        <div className="confirmModal">
            <div className="confirmModalContent">
                <h2>{props.title}</h2>
                {props.productName &&
                    <>
                        <br />
                        <h4>{props.productName}</h4>
                    </>
                }

                {/* Buttons Positioned at Bottom */}
                <div className="confirmModalFooter">
                    <Button variant="secondary" className="confirmModalCancel"
                        onClick={() => {
                            props.setConfirmAnswer(false);
                            props.setShowModal(false);
                        }}>
                        <MdCancel className="confirm-icon" /> {languagePack[language].common.cancel}
                    </Button>

                    <Button variant="primary" className="confirmModalOk"
                        disabled={props.isPending}
                        onClick={() => props.setConfirmAnswer(true)}>
                        {props.isPending ? <Loading />
                            : <>
                                <MdDeleteForever className="confirm-icon" /> {languagePack[language].common.delete}
                            </>
                        }
                    </Button>
                </div>
            </div>
        </div>
    );
}